// ./src/lib/helpers.js
/* global window, process */

import Storage from './Storage';

export const convertToKebab = name => (
  name
    .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
    .toLowerCase()
    .slice(1)
);

export const isProduction = process.env.NODE_ENV === 'production';

export const getWsBusUrl = () => {
  if (process.env.VUE_APP_WS_ADDRESS) {
    return process.env.VUE_APP_WS_ADDRESS;
  }

  let host = process.env.NODE_ENV === 'production'
    ? window.location.host
    : (process.env.VUE_APP_WS_HOST || window.location.host);

  if (/^localhost/.test(host) && !/^localhost/.test(window.location.hostname)) {
    host = host.replace(/localhost/, window.location.hostname);
  }

  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

  return `${proto}//${host}/ws/games`;
};

export const isDebugMode = () => Storage.get('_debug') === 'y';
